/* React */
import { useEffect, useRef } from "react"
/* Router location */
import { useLocation } from "react-router-dom"
/* Environment constants */
import { env } from "../constants"
/* Store and session guard */
import { store } from "../store"
import { checkToken } from "./token"

/* MetrikaTracker — sends a Yandex.Metrika pageview on every client-side route change.
   The counter is initialised in public/index.html, which also counts the first page load,
   so we skip the initial render here to avoid counting that hit twice. */
const MetrikaTracker = () => {

    const location = useLocation()
    const isFirstRender = useRef(true)

    useEffect(() => {
        /* Re-validate the session on every navigation so an expired token is dropped
           before the user lands on a page or triggers a protected action */
        checkToken(store)

        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }
        if (typeof window.ym === "function") {
            window.ym(env.yandexMetrikaId, "hit", window.location.href)
        }
    }, [location.pathname, location.search])

    return null
}

export default MetrikaTracker
